/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Failed_To_Load_NotesInputs */

const en_read_along_failed_to_load_notes = /** @type {(inputs: Read_Along_Failed_To_Load_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load notes`)
};

const es_read_along_failed_to_load_notes = /** @type {(inputs: Read_Along_Failed_To_Load_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar las notas`)
};

/**
* | output |
* | --- |
* | "Failed to load notes" |
*
* @param {Read_Along_Failed_To_Load_NotesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_failed_to_load_notes = /** @type {((inputs?: Read_Along_Failed_To_Load_NotesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Failed_To_Load_NotesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_failed_to_load_notes(inputs)
	return en_read_along_failed_to_load_notes(inputs)
});